import type { ReactNode } from 'react'

interface SectionHeaderTitleProps {
  icon?: ReactNode
  title: string
}

interface SectionHeaderProps extends SectionHeaderTitleProps {
  description?: ReactNode
}

export function SectionHeader({ icon, title, description }: SectionHeaderProps) {
  return (
    <div className="flex flex-col gap-2">
      <SectionHeaderTitle icon={icon} title={title} />

      {description && (
        typeof description === 'string' ? (
          <p className="max-w-lg text-muted-foreground text-xs leading-relaxed sm:text-sm">{description}</p>
        ) : (
          <div className="max-w-lg text-muted-foreground text-xs leading-relaxed sm:text-sm">{description}</div>
        )
      )}
    </div>
  )
}

export function SectionHeaderTitle({ icon, title }: SectionHeaderTitleProps) {
  return (
    <div className="flex items-center gap-2 px-1">
      {icon}
      <span className="font-semibold text-foreground text-sm">{title}</span>
    </div>
  )
}
